import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=dd4ff242&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=dd4ff242&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4ff242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd4ff242')) {
      api.createRecord('dd4ff242', component.options)
    } else {
      api.reload('dd4ff242', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=dd4ff242&scoped=true", function () {
      api.rerender('dd4ff242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/abnormalOrders/processing/DataForm.vue"
export default component.exports